export enum ReportingViewType {
  WEEKLY = "weekly",
  BARCHART = "barchart",
  EXPORT = "export",
}
